// ============================================================================
// CHINESE (SIMPLIFIED) TRANSLATIONS - CHAPTER 1: 创世记
// ============================================================================
// 级别 1-13 (13个级别, 39个问题)

export const chapter1Translations = {
  name: "创世记",
  description: "起初……知识使灵魂焕发生机",
  
  spiritualWisdom: {
    principle: "知识使灵魂焕发生机",
    scripture: "我的民因无知识而灭亡 (何西阿书 4:6)",
    application: "每一节经文的学习，每一个真理的发现都滋养我们的灵魂，坚固我们的信心"
  },
  
  levels: {
    1: {
      name: "创造",
      challenge: "起初，神创造天地……",
      easy: {
        question: "神用多少天创造了世界？",
        options: ["5天", "6天", "7天", "8天"],
        hint: "想想一周中的安息日",
        funFact: "💡 第7天，神歇了祂的工。这就是安息日的起源，每周的休息日！"
      },
      medium: {
        question: "神在第四天创造了什么？",
        options: ["动物", "人", "日月星辰", "植物"],
        hint: "这些受造物照亮大地并标记时间",
        funFact: "🌟 光体被造来定节令、日子、年岁！"
      },
      hard: {
        question: "人按照'神的形象'被造是什么意思？",
        options: [
          "外貌相同",
          "能够创造和爱的能力",
          "天然的不朽",
          "神圣的能力"
        ],
        hint: "这涉及属灵和智力的品质",
        funFact: "✨ 神在我们里面的形象包括创造力、道德意识和爱的能力！"
      }
    },
    
    2: {
      name: "园中的试探",
      challenge: "蛇是田间一切活物中最狡猾的……",
      easy: {
        question: "什么动物在园中试探夏娃？",
        options: ["狮子", "蛇", "鹰", "龙"],
        hint: "这种动物用肚子爬行",
        funFact: "🐍 蛇原本可能有腿，但被诅咒后要用肚子爬行！"
      },
      medium: {
        question: "亚当和夏娃吃了禁果后，他们的第一个反应是什么？",
        options: [
          "他们向神祷告",
          "他们感到羞耻并躲藏",
          "他们吃了更多",
          "他们睡着了"
        ],
        hint: "他们意识到自己的不顺服",
        funFact: "👀 他们的眼睛明亮了，知道自己赤身露体！"
      },
      hard: {
        question: "这个故事关于试探教导了我们什么？",
        options: [
          "试探是不可避免的并且是好的",
          "不顺服神会带来属灵的死亡",
          "知识总是危险的",
          "神造人是为了让人犯罪"
        ],
        hint: "这关乎顺服和后果",
        funFact: "⚡ 罪的工价就是死，但神有恢复的计划！"
      }
    },
    
    3: {
      name: "该隐和亚伯",
      challenge: "你兄弟亚伯在哪里？",
      easy: {
        question: "该隐的职业是什么？",
        options: ["牧羊人", "农夫", "渔夫", "猎人"],
        hint: "他耕种土地",
        funFact: "🌾 该隐是土地的耕种者，像他的父亲亚当一样！"
      },
      medium: {
        question: "神为什么不悦纳该隐的供物？",
        options: [
          "祭物不够大",
          "他的心态和动机有问题",
          "他来得太晚了",
          "神偏爱亚伯"
        ],
        hint: "神看重内心而不是外在",
        funFact: "💝 神不看外貌，而是看内心的态度！"
      },
      hard: {
        question: "这个故事关于嫉妒教导了我们什么？",
        options: [
          "嫉妒是自然的",
          "嫉妒若不加以控制会导致罪恶",
          "神喜欢制造冲突",
          "嫉妒使人更坚强"
        ],
        hint: "这关乎控制我们的负面情绪",
        funFact: "🔥 罪就伏在门前，但我们必须制伏它！"
      }
    },
    
    4: {
      name: "挪亚的洪水",
      challenge: "造一只方舟……",
      easy: {
        question: "挪亚带进方舟的每种洁净动物有多少对？",
        options: ["1对", "2对", "7对", "10对"],
        hint: "比不洁净的动物多",
        funFact: "🦁 洁净动物7对，不洁净的2对，为了献祭和繁殖！"
      },
      medium: {
        question: "洪水持续了多少天？",
        options: ["30天", "40天", "100天", "150天"],
        hint: "这个数字在圣经中象征试炼和洁净",
        funFact: "🌊 雨下了40天，但水势浩大共150天！"
      },
      hard: {
        question: "彩虹象征什么？",
        options: [
          "天气现象",
          "神与人类立约的记号",
          "神的愤怒",
          "洪水的结束"
        ],
        hint: "这是神永恒应许的标志",
        funFact: "🌈 彩虹是神永不再用洪水毁灭全地的约！"
      }
    },
    
    5: {
      name: "巴别塔",
      challenge: "来吧，我们要建造一座城和一座塔……",
      easy: {
        question: "人们想要建造什么？",
        options: ["一座宫殿", "一座塔顶通天的塔", "一座桥", "一座花园"],
        hint: "他们想要到达天",
        funFact: "🏗️ 巴别塔可能是用砖砌成的金字塔形神庙！"
      },
      medium: {
        question: "神如何阻止巴别塔的建造？",
        options: [
          "祂摧毁了塔",
          "祂变乱了他们的语言",
          "祂使地震动",
          "祂派天使"
        ],
        hint: "祂使他们无法沟通",
        funFact: "🗣️ '巴别'的意思是'变乱'，因为神在那里变乱了语言！"
      },
      hard: {
        question: "这个故事关于骄傲教导了我们什么？",
        options: [
          "雄心总是好的",
          "骄傲和想要像神一样会导致混乱",
          "统一总是神的旨意",
          "建造高塔是罪"
        ],
        hint: "这关乎人的骄傲与神的主权",
        funFact: "⚡ 骄傲在败坏以先，狂心在跌倒之前！"
      }
    },
    
    6: {
      name: "亚伯拉罕的呼召",
      challenge: "你要离开本地、本族、父家，往我所要指示你的地去……",
      easy: {
        question: "神呼召亚伯拉罕离开哪里？",
        options: ["埃及", "迦南", "吾珥", "巴比伦"],
        hint: "这是一座位于美索不达米亚的城市",
        funFact: "🏛️ 吾珥是当时一座繁华的城市，有偶像崇拜！"
      },
      medium: {
        question: "神向亚伯拉罕应许了什么？",
        options: [
          "财富",
          "成为大国，地土和后裔",
          "长寿",
          "王位"
        ],
        hint: "三重应许：后裔、土地和祝福",
        funFact: "⭐ 神应许亚伯拉罕的后裔如天上的星那样多！"
      },
      hard: {
        question: "亚伯拉罕的顺服教导了我们关于信心的什么？",
        options: [
          "信心需要看见所有答案",
          "信心是在不知道终点的情况下顺服神",
          "信心是软弱",
          "顺服是可选的"
        ],
        hint: "这关乎信靠并跟随神",
        funFact: "🚶 亚伯拉罕出去，还不知往哪里去，这就是真信心！"
      }
    },
    
    7: {
      name: "以撒的献祭",
      challenge: "神必自己预备作燔祭的羊羔……",
      easy: {
        question: "亚伯拉罕被要求献上谁？",
        options: ["他的仆人", "他的儿子以撒", "他的妻子", "一只羊"],
        hint: "他的独生子，他所爱的",
        funFact: "💝 以撒是应许之子，在亚伯拉罕100岁时出生！"
      },
      medium: {
        question: "最后代替以撒被献上的是什么？",
        options: [
          "一头牛",
          "一只羊羔",
          "角扣在稠密的小树中的公羊",
          "什么都没有"
        ],
        hint: "神预备了一只替代的动物",
        funFact: "🐏 公羊被角缠住，完美地预表了基督的牺牲！"
      },
      hard: {
        question: "这个故事预表了什么属灵真理？",
        options: [
          "神喜悦人的献祭",
          "神会提供祂所要求的",
          "人类牺牲取悦神",
          "亚伯拉罕真的不爱以撒"
        ],
        hint: "这关乎即使不理解也要信靠",
        funFact: "💝 当我们信靠神时，祂总是预备出路！"
      }
    },

    8: {
      name: "雅各和以扫",
      challenge: "将来大的要服事小的……",
      easy: {
        question: "以扫为什么卖了长子的名分？",
        options: ["金子", "一碗红豆汤", "衣服", "酒"],
        hint: "一碗用来充饥的食物",
        funFact: "🍲 一时的饥饿使以扫失去了永恒的祝福！"
      },
      medium: {
        question: "雅各如何欺骗他的父亲以撒？",
        options: [
          "改变了声音",
          "伪装",
          "用山羊皮盖住自己",
          "谎报名字"
        ],
        hint: "为了像他多毛的哥哥",
        funFact: "🎭 瞎眼的以撒认出了气味和触感，却没认出欺骗！"
      },
      hard: {
        question: "这个故事关于我们的选择揭示了什么？",
        options: [
          "欺骗有时是必要的",
          "即时的欲望可能使我们失去命定",
          "神认可狡猾",
          "小的总是被偏爱"
        ],
        hint: "这关乎我们冲动决定的后果",
        funFact: "⚖️ 我们的冲动选择可能带来永恒的后果！"
      }
    },

    9: {
      name: "雅各的梦",
      challenge: "梦见一个梯子立在地上，梯子的头顶着天……",
      easy: {
        question: "雅各在梦中看到了什么？",
        options: [
          "一棵巨树",
          "通往天堂的梯子，上面有天使",
          "一座圣殿",
          "星星"
        ],
        hint: "天地之间的沟通方式",
        funFact: "👼 雅各的梯子象征着天地之间的连接！"
      },
      medium: {
        question: "雅各用作枕头的石头，他后来怎么处理的？",
        options: [
          "打碎了",
          "埋了",
          "立起来并浇油",
          "带走了"
        ],
        hint: "他把它做成了神圣的纪念碑",
        funFact: "🪨 这块石头成为'伯特利'——神的殿！"
      },
      hard: {
        question: "这个异象如何在我们的生活中连接天地？",
        options: [
          "只通过梦",
          "通过建立与神连接的祷告",
          "通过守护天使",
          "通过圣地"
        ],
        hint: "这关乎我们与神的沟通",
        funFact: "🌉 祷告是我们通往天堂的个人梯子！"
      }
    },

    10: {
      name: "约瑟被兄弟们出卖",
      challenge: "看哪，那做梦的来了……",
      easy: {
        question: "约瑟有多少个兄弟？",
        options: ["7个兄弟", "10个兄弟", "11个兄弟", "12个兄弟"],
        hint: "比以色列支派的数目少一个",
        funFact: "👨‍👨‍👦‍👦 雅各的12个儿子将成为以色列的12个支派！"
      },
      medium: {
        question: "约瑟被卖了多少舍客勒银子？",
        options: [
          "10舍客勒",
          "20舍客勒",
          "30舍客勒",
          "50舍客勒"
        ],
        hint: "一个奴隶的价格",
        funFact: "💰 20舍客勒银子，当时一个奴隶的价格！"
      },
      hard: {
        question: "嫉妒如何成为神计划的工具？",
        options: [
          "神认可嫉妒",
          "所行的恶被神转为善",
          "嫉妒是必要的",
          "兄弟们是对的"
        ],
        hint: "这关乎神将恶转为善的旨意",
        funFact: "🎨 神甚至把我们最坏的行为转化为恩典的杰作！"
      }
    },

    11: {
      name: "约瑟在监狱里",
      challenge: "耶和华与约瑟同在，向他施恩……",
      easy: {
        question: "约瑟有什么特别的恩赐？",
        options: [
          "预言",
          "解梦",
          "医治病人",
          "与动物说话"
        ],
        hint: "一种与梦有关的能力",
        funFact: "💭 在古代世界，梦被认为是神的信息！"
      },
      medium: {
        question: "哪些法老的臣仆与约瑟一起在监狱里？",
        options: [
          "宰相和文士",
          "酒政和膳长",
          "医生和守卫",
          "厨师和园丁"
        ],
        hint: "侍奉酒的和侍奉饼的",
        funFact: "🍷 酒政要先尝王的酒，以防中毒！"
      },
      hard: {
        question: "约瑟关于在逆境中忠心教导了我们什么？",
        options: [
          "不公正是可以接受的",
          "对神的忠心超越环境",
          "监狱改变人",
          "必须报复"
        ],
        hint: "这关乎即使在试炼中也要保持忠心",
        funFact: "⭐ 即使在监狱里，约瑟仍保持正直，神提升了他！"
      }
    },

    12: {
      name: "法老的梦",
      challenge: "七只肥母牛……七只瘦母牛……",
      easy: {
        question: "有多少只瘦母牛吃了肥母牛？",
        options: ["5只", "6只", "7只", "8只"],
        hint: "一个完全的数字",
        funFact: "🐄 数字7在圣经中象征完全和丰盛！"
      },
      medium: {
        question: "梦中的7年意味着什么？",
        options: [
          "7年战争然后和平",
          "7年丰收然后7年饥荒",
          "7年疾病然后健康",
          "7年降雨然后干旱"
        ],
        hint: "丰盛和缺乏的循环",
        funFact: "🌾 约瑟通过这个解释拯救了埃及和他的家人！"
      },
      hard: {
        question: "神的智慧如何转化危机？",
        options: [
          "避免所有危机",
          "给予先见之明以便准备",
          "惩罚恶人",
          "使信徒富有"
        ],
        hint: "这关乎准备和预见",
        funFact: "💡 神的智慧将危机转化为拯救的机会！"
      }
    },

    13: {
      name: "兄弟们的和解",
      challenge: "我是约瑟，你们所卖的兄弟……",
      easy: {
        question: "约瑟在便雅悯的口袋里放了什么？",
        options: [
          "金子",
          "他的戒指",
          "他的银杯",
          "一封信"
        ],
        hint: "一个珍贵的私人物品",
        funFact: "🏆 那杯子也用来在水中'占卜'未来！"
      },
      medium: {
        question: "约瑟关于恶被转为善说了什么名言？",
        options: [
          "我饶恕你们",
          "从前你们的意思是要害我，但神的意思原是好的",
          "让我们忘记过去",
          "伸冤在神"
        ],
        hint: "关于神旨意的一句话",
        funFact: "✨ 这句话总结了神在我们生命中的一切旨意！"
      },
      hard: {
        question: "饶恕如何打破复仇的循环？",
        options: [
          "忘记恶行",
          "释放冒犯者和被冒犯者，重新开始",
          "先惩罚",
          "保持距离"
        ],
        hint: "这关乎彼此释放",
        funFact: "🕊️ 约瑟的饶恕预表了神普世的饶恕！"
      }
    }
  }
};

export default chapter1Translations;
